import * as React from 'react';
/**
 *
 * Original name: restore
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A307
 *
 */
export const RestorePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M55 17H43v-3a6.007 6.007 0 0 0-6-6H27a6.007 6.007 0 0 0-6 6v3H9v4h4.265l4.264 29.849A6.03 6.03 0 0 0 23.469 56h17.062a6.03 6.03 0 0 0 5.94-5.151L50.735 21H55v-4Zm-30-3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3H25v-3Zm17.511 36.282A2.01 2.01 0 0 1 40.531 52H23.469a2.01 2.01 0 0 1-1.98-1.718L17.306 21h29.388l-4.183 29.282Z", fill: "currentColor" }),
    React.createElement("path", { d: "M30 34.926V46h4V34.926a16.774 16.774 0 0 0 4.105 2.864l1.789-3.578A11.347 11.347 0 0 1 34 28h-4a11.352 11.352 0 0 1-5.895 6.211l1.789 3.578A16.773 16.773 0 0 0 30 34.926Z", fill: "currentColor" })));
